var React = require('react');

function ModeEdit (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 34.5V42h7.5l22.13-22.13-7.5-7.5L6 34.5zm35.41-20.41c.78-.78.78-2.05 0-2.83l-4.67-4.67c-.78-.78-2.05-.78-2.83 0l-3.66 3.66 7.5 7.5 3.66-3.66z"}));
}

ModeEdit.displayName = "ModeEdit";

ModeEdit.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = ModeEdit;

ModeEdit.default = ModeEdit;



// WEBPACK FOOTER //
// ./node_modules/pui-css-iconography/svgs/mode_edit.svg